module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/afore37-9d46b1c44a750e8cafea79b1197d8d2b.jpg";